import { FunctionComponent } from 'react'
import styles from './childrenTable.module.scss'
import { Table, TableBody, TableCell, TableContainer, TableHead, TableRow } from '@mui/material'
import { useTranslation } from 'react-i18next'
import TableBodyCell from './tableBodyCell'
import Desktop from '@/modules/desktopMobile/desktop'
import { Child } from '@/types/Child'

interface ChildTableProps {
    childs: Child[]
    getParent: () => void
    isNanny: boolean
    isBelgian: boolean
}

const TableChild: FunctionComponent<ChildTableProps> = ({ childs, getParent, isNanny, isBelgian }: ChildTableProps) => {
    const { t } = useTranslation()

    return (
        <TableContainer className={styles.TablePlacement}>
            <Table>
                <TableHead className={styles.TableHeader}>
                    <TableRow>
                        <TableCell sx={{ width: isBelgian ? '25%' : '35%' }} align={'left'}>
                            {t('informations')}
                        </TableCell>
                        {isBelgian && (
                            <TableCell sx={{ width: '25%' }} align={'left'}>
                                {t('preRegistration')}
                            </TableCell>
                        )}
                        <Desktop>
                            <TableCell sx={{ width: isBelgian ? '35%' : '50%' }} align={'left'}>
                                {t('occasionnalPreferences')}
                            </TableCell>
                        </Desktop>
                        <TableCell sx={{ width: '15%' }} align={'center'}>
                            {t('actions')}
                        </TableCell>
                    </TableRow>
                </TableHead>
                {childs && childs.length > 0 ? (
                    childs.map((child, value) => (
                        <TableBody key={value}>
                            <TableBodyCell
                                getParentInfos={getParent}
                                child={child}
                                isNanny={isNanny}
                                isBelgian={isBelgian}
                            />
                        </TableBody>
                    ))
                ) : (
                    <TableBody className={styles.TableBody}>
                        <TableRow>
                            <TableCell colSpan={3}>{t('noChilds')}</TableCell>
                        </TableRow>
                    </TableBody>
                )}
            </Table>
        </TableContainer>
    )
}

export default TableChild
